<template>
    <div>
        <v-data-table v-model="selectedItems" :headers="headers" :items="items" :items-per-page="itemsPerPage"
            :options.sync="options" :server-items-length="totalItems" :loading="isLoading" loader-height="2"
            item-key="id" show-select :loading-text="$t('loadingPleaseWait')" :no-data-text="$t('noUsers')"
            :no-results-text="$t('noResult')" :footer-props="{
                'items-per-page-text': $t('rowsPerPage'),
                'items-per-page-all-text': $t('all'),
            }">
            <template v-slot:item.name="props">
                <v-edit-dialog large persistent transition="slide-y-transition" :cancel-text="$t('cancel')"
                    :save-text="$t('change')" @open="openInfoEditSnack('Редактирование ФИО')"
                    @cancel="openErrorEditSnack($t('cancel'))"
                    @save="updateParam('name', { userId: props.item.id, value: props.item.name })">
                    {{ props.item.name }}
                    <template v-slot:input>
                        <v-text-field v-model="props.item.name" :rules="[rules.required]" single-line counter
                            autofocus></v-text-field>
                    </template>
                </v-edit-dialog>
            </template>
            <template v-slot:item.email="props">
                <v-edit-dialog large persistent transition="slide-y-transition" :cancel-text="$t('cancel')"
                    :save-text="$t('change')" @open="openInfoEditSnack('Редактирование email')"
                    @cancel="openErrorEditSnack($t('cancel'))"
                    @save="updateParam('email', { userId: props.item.id, value: props.item.email })">
                    {{ props.item.email }}
                    <template v-slot:input>
                        <v-text-field v-model="props.item.email" :rules="[rules.required]" single-line counter
                            autofocus></v-text-field>
                    </template>
                </v-edit-dialog>
            </template>
            <template v-slot:item.phone="props">
                <v-edit-dialog large persistent transition="slide-y-transition" :cancel-text="$t('cancel')"
                    :save-text="$t('change')" @open="openInfoEditSnack('Редактирование телефона')"
                    @cancel="openErrorEditSnack($t('cancel'))"
                    @save="updateParam('phone', { userId: props.item.id, value: props.item.phone })">
                    {{ props.item.phone }}
                    <template v-slot:input>
                        <v-text-field v-model="props.item.phone" :rules="[rules.required]" single-line counter
                            autofocus></v-text-field>
                    </template>
                </v-edit-dialog>
            </template>
            <template v-slot:item.createdAt="props">
                {{ getDateString(props.item.createdAt) }}
            </template>
            <template v-slot:item.comment="props">
                <v-edit-dialog persistent transition="slide-y-transition" :return-value.sync="props.item.comment"
                    @open="openInfoEditSnack('Редактирование комментария')" @cancel="openErrorEditSnack($t('cancel'))"
                    @save="updateParam('comment', { userId: props.item.id, value: props.item.comment })">
                    {{ props.item.comment }}
                    <template v-slot:input>
                        <v-text-field v-model="props.item.comment" :rules="[rules.maxLength(255)]" counter="255"
                            single-line autofocus></v-text-field>
                    </template>
                </v-edit-dialog>
            </template>
            <template v-slot:item.actions="props">
                <v-icon dense @click="editClickHandler(props.item)">edit</v-icon>
            </template>
        </v-data-table>

        <edit-modal v-model="editModal" :user="editableUser" @save="updateUser"></edit-modal>

        <edit-snackbar v-model="isOpenEditSnack" :snack-text="editSnackText" :snack-color="editSnackColor"
            @close="resetEditSnack"></edit-snackbar>
    </div>
</template>

<script>
import { UsersService } from '../../../services';
import { MixinTextFieldValidators, MixinEditSnack, MixinTableLoadState } from '../../../mixins';
import EditModal from './EditModal';
import EditSnackbar from '../../snackbars/edit-snackbar/EditSnackbar';

export default {
    name: 'BuyersTable',
    mixins: [MixinTextFieldValidators, MixinEditSnack, MixinTableLoadState],
    components: {
        EditModal,
        EditSnackbar,
    },
    props: {
        filters: {
            required: false,
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            headers: [],
            items: [],
            options: {},
            itemsPerPage: 10,
            editModal: false,
            totalItems: null,
            editableUser: null,
        };
    },
    computed: {
        nameValidators() {
            return [this.validators.required];
        },
        emailValidators() {
            return [this.validators.required];
        },
        phoneValidators() {
            return [this.validators.required];
        },
        commentValidators() {
            return [this.validators.maxLength(255)];
        },
        selectedItems: {
            get() {
                return this.$store.state.selectedUsers;
            },
            set(value) {
                this.$store.commit('setSelectedUsers', value);
            }
        }
    },
    methods: {
        editClickHandler(user) {
            this.editableUser = user;
            this.editModal = true;
        },
        setHeaders() {
            UsersService.setLocale(this.$store.getters.appLanguage);
            UsersService.getBuyersHeaders()
                .then(res => {
                    this.headers = res.data;
                })
                .catch(err => this.emitTableLoadError(err));
        },
        setItems() {
            if (!this.startTableLoading()) return;

            const params = { ...this.options, filters: this.filters };
            UsersService.setLocale(this.$store.getters.appLanguage);
            UsersService.getBuyers(params)
                .then(res => {
                    this.items = res.data.data;
                    this.totalItems = res.data.total;
                })
                .catch(err => this.emitTableLoadError(err))
                .finally(() => {
                    this.stopTableLoading();
                });
        },
        isValid(param, value) {
            const nameValidators = param + 'Validators';

            return this[nameValidators] ? this.isAllValidatorsPassed(this[nameValidators], value) : true;
        },
        updateParam(param, data) {
            this.resetEditSnack();

            if (this.isValid(param, data.value)) {
                UsersService.updateParams(param, data)
                    .then(() => {
                        this.openSuccessEditSnack();
                    })
                    .catch(() => {
                        this.openErrorEditSnack();
                    })
            }
        },
        updateUser(user) {
            UsersService.updateUser(user)
                .then(res => {
                    if (res.data) {
                        this.replaceUserData(user);
                        this.openSuccessEditSnack();
                    }
                })
                .catch(() => {
                    this.openErrorEditSnack();
                });
        },
        replaceUserData(user) {
            const { id, ...data } = user;
            const idx = this.items.findIndex(item => item.id === id);

            Object.keys(data).forEach(key => {
                this.items[idx][key] = data[key];
            })
        },
        getDateString(timestamp) {
            const dateObj = new Date(timestamp * 1000)
            const dateString = dateObj.toLocaleDateString('uk-UA')
            return dateString.replace(/\./g, "-")
        },
    },
    created() {
        this.setHeaders();
    },
    watch: {
        filters: {
            handler() {
                this.setItems();
            },
            deep: true,
        },
        options: {
            handler() {
                this.setItems();
            },
            deep: true,
        },
        editModal(value) {
            if (!value) {
                this.editableUser = null;
            }
        },
    },
};
</script>

<style scoped></style>
